webpackJsonp([127],{

/***/ 1099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    methods: {
        searchIconClick: function searchIconClick() {
            alert('You wanna make a search?');
        }
    }
});

/***/ }),

/***/ 1100:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("With Material Design Icons")]), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon": "magnify",
      "icon-clickable": ""
    },
    on: {
      "icon-click": _vm.searchIconClick
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Email",
      "type": "email",
      "icon": "email"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Credit card",
      "icon": "credit-card"
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("With FontAwesome")]), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Search...",
      "type": "search",
      "icon-pack": "fas",
      "icon": "search"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Email",
      "type": "email",
      "icon-pack": "fas",
      "icon": "envelope"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Credit card",
      "icon-pack": "far",
      "icon": "credit-card"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1099),
  /* template */
  __webpack_require__(1100),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/127.5c66525a24354b760e74.js